// extracted by mini-css-extract-plugin
export default {"buttons":"DialogPopUpConfirmation_buttons__aNHTA"};